/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_PublicInputs */

const en_admin_questionnaire_editor_public = /** @type {(inputs: Admin_Questionnaire_Editor_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone can retrieve answers to the questions via public API`)
};

const nl_admin_questionnaire_editor_public = /** @type {(inputs: Admin_Questionnaire_Editor_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iedereen kan antwoorden op de vragen ophalen via de openbare API`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_PublicInputs) => LocalizedString} */
const de_admin_questionnaire_editor_public = en_admin_questionnaire_editor_public;

/** @type {(inputs: Admin_Questionnaire_Editor_PublicInputs) => LocalizedString} */
const es_admin_questionnaire_editor_public = en_admin_questionnaire_editor_public;

/** @type {(inputs: Admin_Questionnaire_Editor_PublicInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_public = en_admin_questionnaire_editor_public;

/** @type {(inputs: Admin_Questionnaire_Editor_PublicInputs) => LocalizedString} */
const it_admin_questionnaire_editor_public = en_admin_questionnaire_editor_public;

/** @type {(inputs: Admin_Questionnaire_Editor_PublicInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_public = en_admin_questionnaire_editor_public;

/** @type {(inputs: Admin_Questionnaire_Editor_PublicInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_public = en_admin_questionnaire_editor_public;

/** @type {(inputs: Admin_Questionnaire_Editor_PublicInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_public = en_admin_questionnaire_editor_public;

/** @type {(inputs: Admin_Questionnaire_Editor_PublicInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_public = en_admin_questionnaire_editor_public;

/**
* | output |
* | --- |
* | "Anyone can retrieve answers to the questions via public API" |
*
* @param {Admin_Questionnaire_Editor_PublicInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_public = /** @type {((inputs?: Admin_Questionnaire_Editor_PublicInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_PublicInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_public(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_public(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_public(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_public(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_public(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_public(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_public(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_public(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_public(inputs)
	return ro_admin_questionnaire_editor_public(inputs)
});
export { admin_questionnaire_editor_public as "admin.questionnaire_editor.public" }